import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/time',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
